import React from 'react';
import PolicyPage from './PolicyPage';
import seguranca from './content/seguranca';

/**
 * Única página desta pasta que não traz o documento na íntegra.
 *
 * O documento aprovado descreve a organização interna da Empiria e os
 * controles do ambiente de tecnologia — publicá-lo inteiro seria entregar a
 * planta da casa. Mas alguma página precisa existir: o item 10.1 da Política
 * de Cookies e Privacidade manda o titular acessar esta política.
 */
const Seguranca = () => (
    <PolicyPage
        titulo="Política de Segurança Cibernética e da Informação da Empiria"
        versao="Resumo da versão publicada no dia 22 de julho de 2026"
        blocos={seguranca}
    />
);

export default Seguranca;
